module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/GM-bbcd8c06ca3576902aff665e5f1ae520.png";